<!-- BANNER DESKTOP -->
<div class="home-banner desktop-banner" *ngIf="banners.length > 0">
    <owl-carousel-o [options]="customOptions">
        <ng-container *ngFor="let banner of banners">
            <ng-template carouselSlide>
                <img class="banner-image" [src]="banner.urlFoto" [defaultImage]="defImgBanner" [alt]="banner.al"
                    [title]="banner.al" (click)="goToBanner(banner)" />
            </ng-template>
        </ng-container>
    </owl-carousel-o>
</div>
<!-- BANNER MOBILE -->
<div class="home-banner mobile-banner" *ngIf="banners.length > 0">
    <owl-carousel-o [options]="customOptions">
        <ng-container *ngFor="let banner of banners">
            <ng-template carouselSlide>
                <img class="banner-image" [src]="banner.urlFotoParaMovil" [defaultImage]="defImgBanner"
                    [alt]="banner.al" [title]="banner.al" (click)="goToBanner(banner)" />
            </ng-template>
        </ng-container>
    </owl-carousel-o>
</div>
<!-- CATÁLOGO -->
<section class="catalog-section">
    <div class="catalog-header">
        <div class="catalog-intro">
            <span class="catalog-eyebrow">
                CATÁLOGO
            </span>
            <h1>
                ¿Qué se te antoja hoy?
            </h1>
            <p>
                Estas son nuestras familias de producto.
                Mándanos mensaje y te compartimos el catálogo
                completo con precios y disponibilidad de tu sucursal.
            </p>
        </div>
        <div class="catalog-navigation">
            <button type="button" class="catalog-arrow" (click)="scrollLines('left')" aria-label="Anterior">
                <span class="arrow-icon arrow-left"></span>
            </button>

            <button type="button" class="catalog-arrow" (click)="scrollLines('right')" aria-label="Siguiente">
                <span class="arrow-icon arrow-right"></span>
            </button>
        </div>
    </div>
    <div class="catalog-slider" #linesSlider>
        <div class="catalog-item" *ngFor="let line of lines" (click)="selectedLine(line)">
            <div class="catalog-card">
                <img [src]="line.urlFoto" [defaultImage]="defImgLinea" [alt]="line.descripcion" />
            </div>
            <span class="catalog-name">
                {{ line.descripcion }}
            </span>
        </div>
    </div>

    <div class="catalog-footer">
        <button type="button" class="catalog-button" (click)="goToCatalog()">
            Catálogo completo
        </button>
    </div>
</section>